import React from "react";
import Layout from "components/layout";
import SEO from "components/seo";
import WashingtonDc from "components/locationIndexPages/Washington-DC";

export default function index() {
  const title = "Washington DC Translation Services";
  const description =
    "High-quality translation services in Washington DC. Over 120 languages and 950+ language pairings supported. 1-Year Guarantee | Fast Delivery | 24/7 Availability lation Services";
  const keywords = "Washington DC Translation Services";
  return (
    <Layout>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        slug="/locations/washington-dc-translation-services/"
      />
      <WashingtonDc />
    </Layout>
  );
}
